// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
const enum MiniCommonIcons {
    OfficeLogo = 'OfficeLogo',
    OutlookLogo = 'OutlookLogo',
}

export default MiniCommonIcons;
